import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-692c8d48"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "wrap bar" }
const _hoisted_3 = { class: "links" }
const _hoisted_4 = { class: "lang" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "·", -1))
const _hoisted_6 = ["aria-expanded", "aria-label"]
const _hoisted_7 = {
  width: "22",
  height: "22",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_8 = {
  key: 0,
  "stroke-linecap": "round",
  "stroke-width": "2",
  d: "M4 7h16M4 12h16M4 17h16"
}
const _hoisted_9 = {
  key: 1,
  "stroke-linecap": "round",
  "stroke-width": "2",
  d: "M6 18L18 6M6 6l12 12"
}
const _hoisted_10 = {
  key: 0,
  id: "mobile-menu",
  class: "mobile"
}
const _hoisted_11 = { class: "m-lang" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "·", -1))

import { ref, onMounted, onUnmounted } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import MadarionLogo from "./MadarionLogo.vue";
import { useLocalePath } from "../composables/useLocalePath";
import { localePath, Locale } from "../utils/locale";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppNavbar',
  setup(__props) {

const { locale } = useI18n();
const route = useRoute();
const lp = useLocalePath();
const scrolled = ref(false);
const menuOpen = ref(false);

// The same page in the other language: a real link, so crawlers and screen readers follow it too.
function switchTo(lang: Locale) {
  return {
    path: localePath((route.meta.basePath as string) ?? "/", lang),
    hash: route.hash
  };
}

function onScroll() {
  scrolled.value = window.scrollY > 24;
}

onMounted(() => {
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });
});
onUnmounted(() => window.removeEventListener("scroll", onScroll));

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(['navbar', { scrolled: scrolled.value }]),
    "aria-label": _ctx.$t('nav.label')
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: _unref(lp)('/'),
        class: "logo-link"
      }, {
        default: _withCtx(() => [
          _createVNode(MadarionLogo)
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: { path: _unref(lp)('/'), hash: '#services' },
          class: "nav-link"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("nav.services")), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, {
          to: { path: _unref(lp)('/'), hash: '#ai' },
          class: "nav-link"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("nav.ai")), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, {
          to: _unref(lp)('/connectera'),
          class: "nav-link"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("nav.connectera")), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, {
          to: { path: _unref(lp)('/'), hash: '#approach' },
          class: "nav-link"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("nav.approach")), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, {
          to: _unref(lp)('/about'),
          class: "nav-link"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("nav.about")), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: switchTo('fr'),
            hreflang: "fr",
            lang: "fr",
            "aria-current": _unref(locale) === 'fr' ? 'true' : undefined,
            class: _normalizeClass(_unref(locale) === 'fr' ? 'on' : '')
          }, {
            default: _withCtx(() => [
              _createTextVNode("FR")
            ]),
            _: 1
          }, 8, ["to", "aria-current", "class"]),
          _hoisted_5,
          _createVNode(_component_router_link, {
            to: switchTo('en'),
            hreflang: "en",
            lang: "en",
            "aria-current": _unref(locale) === 'en' ? 'true' : undefined,
            class: _normalizeClass(_unref(locale) === 'en' ? 'on' : '')
          }, {
            default: _withCtx(() => [
              _createTextVNode("EN")
            ]),
            _: 1
          }, 8, ["to", "aria-current", "class"])
        ])
      ]),
      _createVNode(_component_router_link, {
        to: _unref(lp)('/contact'),
        class: "cta"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("nav.cta")), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("button", {
        class: "toggle",
        "aria-expanded": menuOpen.value ? 'true' : 'false',
        "aria-controls": "mobile-menu",
        "aria-label": _ctx.$t('nav.toggle'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (menuOpen.value = !menuOpen.value))
      }, [
        (_openBlock(), _createElementBlock("svg", _hoisted_7, [
          (!menuOpen.value)
            ? (_openBlock(), _createElementBlock("path", _hoisted_8))
            : (_openBlock(), _createElementBlock("path", _hoisted_9))
        ]))
      ], 8, _hoisted_6)
    ]),
    (menuOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_router_link, {
            to: { path: _unref(lp)('/'), hash: '#services' },
            class: "m-link",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (menuOpen.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("nav.services")), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode(_component_router_link, {
            to: { path: _unref(lp)('/'), hash: '#ai' },
            class: "m-link",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (menuOpen.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("nav.ai")), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode(_component_router_link, {
            to: _unref(lp)('/connectera'),
            class: "m-link",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (menuOpen.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("nav.connectera")), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode(_component_router_link, {
            to: { path: _unref(lp)('/'), hash: '#approach' },
            class: "m-link",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (menuOpen.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("nav.approach")), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode(_component_router_link, {
            to: _unref(lp)('/about'),
            class: "m-link",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (menuOpen.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("nav.about")), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode(_component_router_link, {
            to: _unref(lp)('/contact'),
            class: "m-link",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (menuOpen.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("nav.contact")), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_router_link, {
              to: switchTo('fr'),
              hreflang: "fr",
              lang: "fr",
              class: _normalizeClass(_unref(locale) === 'fr' ? 'on' : ''),
              onClick: _cache[7] || (_cache[7] = ($event: any) => (menuOpen.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode("FR")
              ]),
              _: 1
            }, 8, ["to", "class"]),
            _hoisted_12,
            _createVNode(_component_router_link, {
              to: switchTo('en'),
              hreflang: "en",
              lang: "en",
              class: _normalizeClass(_unref(locale) === 'en' ? 'on' : ''),
              onClick: _cache[8] || (_cache[8] = ($event: any) => (menuOpen.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode("EN")
              ]),
              _: 1
            }, 8, ["to", "class"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})